import jwtToken from '@/assets/jwt-token.ts';
import * as types from '@/assets/mutations-types.ts';

import axios from 'axios';

export default {
  state: {
      errors: {
        email: null,
        password: null,
      },
  },
  mutations: {
      [types.LOGIN_SUCCESS](state, payload) {
        state.errors.email = null;
        state.errors.password = null;
      },
      [types.LOGIN_FAILURE](state, payload) {
        state.errors.email = payload.errors.email ? payload.errors.email[0] : null;
        state.errors.password = payload.errors.password ? payload.errors.password[0] : null;
      },
      [types.CLEAR_LOGIN_ERRORS](state, payload) {
        state.errors.email = null;
        state.errors.password = null;
      },
  },
  actions: {
    loginRequest: ({dispatch}, payload) => {
        return new Promise((resolve, reject) => {
        axios.post('auth/login', payload)
        .then(({data, status}) => {
          // console.log("payload: loginRequest --->");
          if(status === 200) {
            dispatch('setAuthUser', payload);
            dispatch('loginSuccess', data);
            resolve(data);
          }
        })
        .catch((error) => {
          // console.log(error.response.data);
          reject(error.response.data);
        });
      });
    },
    loginSuccess: ({commit, dispatch}, jwtTokenObj) => {
        
      jwtToken.setToken(jwtTokenObj.auth_token);

      commit({ type: types.LOGIN_SUCCESS });

    },
    loginFailure: ({commit, dispatch}, body) => {
      // body es error message when a user input incorrect credentials
      commit({
          type: types.LOGIN_FAILURE,
          errors: body || [],
      });

      if(body) {
          dispatch('showErrorNotification', body);
      }
    },
    clearLoginErrors: ({commit}) => {
      commit({
          type: types.CLEAR_LOGIN_ERRORS,
      });
    },
    logoutRequest: ({dispatch}) => {
      jwtToken.removeToken();

      return new Promise((resolve, reject) => {
          dispatch('unsetAuthUser');
          resolve();
      });
    },
  },
};